<template>
    <footer id="footer">
        <div class="inner">
            <div class="f-logo"><img src="@/assets/images/logo_footer.png" alt="한국토지신탁"></div>

            <div class="f-info">
                <ul>
                    <li><span>주소</span>06132 서울 강남구 테헤란로 137(역삼동) 코레이트타워 16F~19F (주)한국토지신탁</li>
                    <li><span>대표번호</span>02-3451-1100 / 02-3451-1114</li>
                </ul>
                <p class="copyright">Ⓒ KOREIT. ALL RIGHTS RESERVED.</p>
            </div>

            <div class="f-util" @change="eventHandler.move()">
                <select v-model="state.siteVal">
                    <option value="" selected>Family Site</option>
                    <option value="https://www.koreit.co.kr/">한국토지신탁</option>
                </select>
            </div>
        </div>
        <button type="button" title="상단으로 이동" class="go-top" @click="eventHandler.onTopScrollClick"><span class="text_hidden">상단으로 이동</span></button>
    </footer>
</template>
<script>
import { reactive } from '@vue/reactivity';
export default {
    setup() {

        // state (변수)
        const state = reactive({
            siteVal: "",
        });

        // 이벤트 핸들러
        const eventHandler = {

            /**
             * 최상단으로 스크롤 이동 버튼 클릭 이벤트 처리
             */
            onTopScrollClick: () => {

                window.scrollTo({ top: 0, behavior: "smooth" }); 
            },
            move: () => {
                if(state.siteVal != ""){

                    location.href = state.siteVal;
                }
            },
        }

        return {
            state,
            eventHandler,
        }
        
    },
}
</script>